import { render } from "./feedHeader.vue?vue&type=template&id=1ba88971&scoped=true"
import script from "./feedHeader.vue?vue&type=script&lang=js"
export * from "./feedHeader.vue?vue&type=script&lang=js"

import "./feedHeader.vue?vue&type=style&index=0&id=1ba88971&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ba88971"]])

export default __exports__